import SectionHeading from "./SectionHeading";
import { columns } from "@/mocks/critter";

const iconTones = [
  "bg-primary-100 text-primary-700",
  "bg-accent-100 text-accent-800",
  "bg-secondary-100 text-secondary-800",
  "bg-background-300 text-foreground-700",
  "bg-accent-200/70 text-accent-900",
];

export default function ColumnsSection() {
  return (
    <section id="columns" className="scroll-mt-24 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="Columns"
          title="五大栏目，把复杂讲清楚"
          desc="每一篇都归入独立栏目，让你按兴趣持续追更，也方便快速找到自己关心的领域。"
          align="center"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-5">
          {columns.map((c, i) => (
            <a
              key={c.name}
              href="#reports"
              className="group flex flex-col rounded-lg border border-background-300 bg-background-50 p-6 transition-all hover:-translate-y-1 hover:border-accent-400"
            >
              <span
                className={`flex h-12 w-12 items-center justify-center rounded-md ${iconTones[i % iconTones.length]}`}
              >
                <i className={`${c.icon} text-xl`}></i>
              </span>
              <span className="mt-4 font-label text-[10px] uppercase tracking-[0.2em] text-foreground-400">
                {c.en}
              </span>
              <h3 className="mt-1 font-heading text-lg font-bold text-foreground-950 group-hover:text-accent-800">
                {c.name}
              </h3>
              <p className="mt-2 flex-1 text-[13px] leading-relaxed text-foreground-600">{c.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-xs font-semibold text-primary-600">
                <i className="ri-file-text-line"></i> {c.count} 篇深度内容
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}